import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  height: 100%;
`;

const Title = styled.div`
  margin: 16px 0px;
  color: #080808;
  font-size: 20px;
`;

const Text = styled.div`
  font-size: 12px;
  color: #666666;
  opacity: 0.6;
`;

function DrawerMenu({ Icon, title, text }: IDrawerMenu) {
  return (
    <Wrapper>
      {Icon && Icon}
      <Title>{title}</Title>
      <Text>{text}</Text>
    </Wrapper>
  );
}

export interface IDrawerMenu {
  Icon: any;
  title: string;
  text: string;
}

export default DrawerMenu;
